__turbopack_context__.v({
  "colorPickerPalette": "color-picker-module__X8mfWq__colorPickerPalette",
});
